(function() {
    'use strict';

    var directiveName = 'apFocusStr';
    
    angular.module('aprima-core-ui').directive(directiveName, ['$parse', 'inputSelection', function ($parse, inputSelection) {
        var defaultString = '_';

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                var _element = inputSelection.getChildElement(element);

                var parsedString = $parse(attrs[directiveName]);
                var searchString = defaultString;
                if(parsedString.constant) {
                    searchString = parsedString(scope) || defaultString;
                }

                element.on('focus', handleFocus);

                scope.$on('$destroy', function(){
                    element.off('focus', handleFocus);
                });

                function handleFocus() {
                    updateSearchString();
                    inputSelection.trySelectStr(_element, ngModel, searchString, 0);
                }

                function updateSearchString() {
                    if(!parsedString.constant) {
                        searchString = parsedString(scope) || defaultString;
                    }
                }
            }
        };
    }]);
})();